import { getIn } from 'seamless-immutable';
import { getImage } from '@catalogo/service-americanas-common/src/helpers/image';

export const existOffer = product => !!product?.skus[0]?.offers?.result?.length;

export const fmtBuyTogetherProducts = (data, selectedSku, handleClick, category) => {
  const temp = data.map(product => {
    const image = getImage(product.images[0], 'big');
    const name = getIn(product, ['name']);
    const offer = getIn(product, ['skus', 0, 'offers', 'result', 0], '');
    const salesPrice = getIn(offer, ['salesPrice']);
    const sku = getIn(offer, ['sku']);
    const sellerId = getIn(offer, ['seller', 'id']);
    const sellerName = getIn(offer, ['seller', 'name']);
    const sellerType = product?.sellerTypeClassification;
    const id = getIn(product, ['id']);
    const condition = getIn(offer, ['condition']);
    const isSelected = selectedSku[id]?.isSelected;
    const rating = product?.rating;

    return {
      image,
      name,
      salesPrice,
      sku,
      isSelected,
      sellerId,
      sellerName,
      sellerType,
      id,
      condition,
      handleClick,
      rating,
      category,
      isFromBuyTogether: true,
    };
  });

  return temp;
};

export const fmtMainProduct = (currentSku, product) => {
  const image = getImage(currentSku?.images?.[0], 'large');
  const name = getIn(currentSku, ['name']);
  const offer = getIn(currentSku, ['offers', 'result', 0], '');
  const salesPrice = getIn(offer, ['salesPrice']);
  const rating = getIn(product, ['rating']);

  return { image, name, salesPrice, rating };
};

export const fmtExtraProducts = (products, selectedSku) =>
  products
    .filter(product => selectedSku[product.id]?.isSelected)
    .map(item => ({
      sku: selectedSku[item.id].sku,
      sellerId: selectedSku[item.id].sellerId,
      condition: selectedSku[item.id].condition,
      salesPrice: selectedSku[item.id].salesPrice,
    }));

export const toggleSelectedSku = (selectedSku, setSelectedSku, dispatchMetrics) => newProduct => {
  sendMetrics(dispatchMetrics, newProduct.isSelected);

  setSelectedSku({
    ...selectedSku,
    [newProduct.id]: { ...newProduct, isSelected: !newProduct.isSelected },
  });
};

export const sendMetrics = (dispatchMetrics, isSelected) => {
  dispatchMetrics('event:track', {
    action: isSelected ? 'remove' : 'add',
    category: 'product',
    label: 'compre-junto',
  });
};

export const handleClickBuyButton = (dispatchMetrics, url, products) => () => {
  dispatchMetrics('addToCart', {
    action: 'add',
    category: 'product',
    label: 'compre-junto',
    products,
  });

  window.location.href = url;
};
